module.exports = __webpack_public_path__ + "img/Window_thumbnail.d97d1bfb.webp";